import { Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { RiDeleteBinLine, RiEdit2Line, RiRoadMapLine } from "react-icons/ri";

type EnderecoData = {
	id: string;
	cep: string;
	uf: string;
	cid: string;
	cidcod: string;
	bai: string;
	endereco: string;
	num: string;
	comp?: string;
	ponto_ref?: string;
	emp_cod: string;
}
type EnderecoCadProps ={
	endereco: EnderecoData;
	setEndModal: (end: EnderecoData) => void;
	setIsNewEndClienteModal: (isOpen: boolean) => void;
	enderecos: EnderecoData[];
	setEnderecos: (enderecos: EnderecoData[]) => void;
}

const EnderecoCadastro: React.FC<EnderecoCadProps> = ({
	endereco,
	setEndModal,
	setIsNewEndClienteModal,
	enderecos,
	setEnderecos,
}) => {
	function handleDeleteEnd() {
		const endIndex = enderecos.findIndex(end => end.id === endereco.id);
		enderecos.splice(endIndex, 1);
		setEnderecos([...enderecos]);
	}

	return (
		<Flex
			align="center"
			justify="space-between"
			bg="gray.40"
			borderColor="gray.100"
			borderWidth={1}
			borderRadius={8}
			py="2"
			px="4"
			_hover={{
				boxShadow: 'lg'
			}}
		>
			<Flex
				w="100%"
				align="center"
				cursor="pointer"
				onClick={() => {
					setEndModal(endereco);
					setIsNewEndClienteModal(true);
				}}
			>
				<Icon as={RiRoadMapLine} fontSize="26" mr="4" color="gray.600" />
				<Box>
					<Text color="gray.600" fontSize="15">{endereco.endereco}, {endereco.num}</Text>
					<Text color="gray.500" fontSize="14">
						{endereco.comp ? `${endereco.comp}, ` : ''}{endereco.bai}, {endereco.cid} - {endereco.uf}
						{endereco.ponto_ref ? ` - ${endereco.ponto_ref}` : ''}
					</Text>
				</Box>
			</Flex>

			<Flex justify="flex-end">
				<Button
					p={0}
					size="sm"
					bg="transparent"
					_hover={{ bg: 'transparent' }}
					onClick={() => {
						setEndModal(endereco);
						setIsNewEndClienteModal(true);
					}}
				>
					<Icon as={RiEdit2Line} fontSize="20" color="blue.100" />
				</Button>

				<Button
					p={0}
					size="sm"
					ml="1"
					bg="transparent"
					_hover={{ bg: 'transparent' }}
					onClick={handleDeleteEnd}
				>
					<Icon as={RiDeleteBinLine} fontSize="20" color="red.500" />
				</Button>
			</Flex>
		</Flex>
	)
}

export default EnderecoCadastro;
